import moment from 'moment';

export default {
  data() {
    return {
      reservationQueryDenyOptions: [
        {
          label: 'Dates indisponibles',
          value: 'dates_not_available',
        },
        {
          label: 'Le voyageur ne correspond pas aux attentes',
          value: 'Demande non adaptée',
        },
        {
          label: "En attente d'une meilleure réservation",
          value: 'waiting_for_better_reservation',
        },
        {
          label: "Pas à l'aise avec la demande",
          value: 'not_comfortable',
        },
      ],
    };
  },
  computed: {
    title() {
      const names = this.conversation?.guestNames || [];
      if (names.length <= 1) return names.join('');
      return `${names.slice(0, -1).join(', ')} et ${names[names.length - 1]}`;
    },
    isReservationConfirmed() {
      return this.threadType === 'reservation_confirmed';
    },
    isReservationQuery() {
      return this.threadType === 'reservation_query';
    },
    isReservationCancelled() {
      return this.threadType === 'reservation_cancelled';
    },
    isReservationRetracted() {
      return this.threadType === 'reservation_retracted';
    },
    isReservationDenied() {
      return this.threadType === 'reservation_denied';
    },
    isReservationExpired() {
      return this.threadType === 'reservation_timeout';
    },
    isInquiry() {
      return this.threadType === 'inquiry_active';
    },
    isInquiryExpired() {
      return this.threadType === 'inquiry_timeout';
    },
    isSpecialOfferActive() {
      return this.threadType === 'special_offer_active';
    },
    isSpecialOfferVoided() {
      return this.threadType === 'special_offer_voided';
    },
    isInquiryDeclined() {
      return this.threadType === 'inquiry_declined';
    },
  },
  methods: {
    isSpecialOfferExpired(expiry) {
      return this.isInquiryDeclined && moment.utc().isAfter(expiry);
    },
  },
};
